import { TripTypeOptions } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { PriceTypes, ShopTypes } from '../../constants/postData.constants';
import { PostDataSearchLocalStorage } from '../../models/postData-search-local-storage.interface';

export const retrievePostDataInitialState = (): PostDataSearchLocalStorage => {
  return {
    action: 'findFlights',
    actionType: '',
    awardTravel: 'false',
    bestFare: 'BE',
    bookingPostVerify: 'RTR_YES',
    cabinFareClass: null,
    cacheKey: '',
    currentSolution: { sliceIndex: 0, solutionId: '' },
    datesFlexible: false,
    deltaOnlySearch: 'false',
    destinationAirportRadius: { measure: 100, unit: 'MI' },
    flexAirport: false,
    flexCalendar: false,
    flexDate: false,
    flexDaysWeeks: '',
    isEdocsSearch: false,
    initialSearchBy: {
      fareFamily: 'BE',
      cabinFareClass: null,
      meetingEventCode: '',
      refundable: false,
      flexAirport: false,
      flexDate: false,
      flexDaysWeeks: '',
      deepLinkVendorId: ''
    },
    is_Flex_Search: true,
    meetingEventCode: '',
    nonstopFlightsOnly: 'false',
    originAirportRadius: { measure: 100, unit: 'MI' },
    passengerInfo: [],
    passengers: [{ count: '1', type: 'ADT' }],
    priceSchedule: '',
    priceType: PriceTypes.REVENUE,
    refundableFlightsOnly: false,
    schedulePrice: 'price',
    searchByCabin: true,
    searchByFareClass: null,
    searchType: 'simple',
    segments: [],
    shopType: ShopTypes.MONEY,
    shopWithMiles: '',
    tripType: TripTypeOptions.ROUND_TRIP,
    upgradeRequest: false,
    includeBasicFaresUnchecked: false
  };
};
